import React, { useState } from "react";
import { connect } from "react-redux";

import { serverResponse } from "../../util/fakeServer";
import { defaultLanguage, hasProducts } from "../../helper/utility";
import { language } from "../../languageProvider/language/language";
import ManagerFactory from "../../managers/ManagerFactory";
import GroceryList from "../floatingGroceryList/GroceryList";
import "./floatingCart.css";

const manager = ManagerFactory.getManager();

// Accesso al carrello per i tenant senza sidebar sinistra.
// Sotto i 576px il carrello e' gia' coperto da Header (allow_login false) o da
// FloatingMenu (allow_login true); da 576px in su l'unico punto di accesso e'
// la Sidebar, che pero' non viene renderizzata quando left_bar e' false. In
// quel caso il carrello resterebbe irraggiungibile pur restando attivi i
// pulsanti "aggiungi alla lista": questo bottone copre proprio quel buco.
const FloatingCartButton = (props) => {
  const [popoverOpen, setPopoverOpen] = useState(false);
  const toggle = () => setPopoverOpen(!popoverOpen);

  const { config } = serverResponse;
  // Stesso default della Sidebar in DashboardLayout: left_bar assente = sidebar
  // presente, quindi qui non serve nessun bottone.
  const leftBar = config?.left_bar ?? true;

  if (leftBar || config.hide_grocery_list || !hasProducts()) return null;

  const label = config.send_grocery_list_to_market
    ? language[defaultLanguage].il_tuo_carrello
    : language[defaultLanguage].la_tua_lista_della_spesa;

  return (
    <>
      <button
        type="button"
        id="floating-cart"
        className="floating-cart-btn d-none d-sm-flex"
        title={label}
        aria-label={label}
        onClick={toggle}
      >
        {manager.getCartIcon()}
        {props.groceryList.length > 0 && (
          <span className="floating-cart-badge">
            {props.groceryList.length}
          </span>
        )}
      </button>
      <GroceryList
        isOpen={popoverOpen}
        toggle={toggle}
        placement={"right"}
        target="floating-cart"
        isMobile={false}
      />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    groceryList: state.groceryList.list,
  };
};

export default connect(mapStateToProps)(FloatingCartButton);
